const Map = () => {
    return (
        <>
            <div className="main">
                <iframe
                    title="Shaheed-e-Millat Rd, BMCHS Sharafabad, Karachi, Karachi City, Sindh, Pakistan"
                    loading="lazy"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3619.5010989997154!2d67.06124457515268!3d24.88088357791594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33eec7bb25631%3A0x5c41956655801d43!2sAl-Khaleej%20Tower%2C%20Shaheed-e-Millat%20Rd%2C%20BMCHS%20Sharafabad%2C%20Karachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1685993169483!5m2!1sen!2s"
                    width="100%"
                    height="500"
                    style={{ border: 0, borderRadius: '8px' }}
                    allowFullScreen
                ></iframe>
            </div>
        </>
    )
}

export default Map
